import { NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FuseNavigationModule } from '@fuse/components/navigation';
import { FuseLoadingBarModule } from '@fuse/components/loading-bar';
import { FuseFullscreenModule } from '@fuse/components/fullscreen/fullscreen.module';
import { UserModule } from 'app/shared/components/user/user.module';
import { ClassyLayoutComponent } from 'app/shared/components/layout/layouts/vertical/classy/classy.component';
import { LanguagesModule } from 'app/shared/components/languages/languages.module';
import { MessagesModule } from 'app/shared/components/messages/messages.module';
import { NotificationsModule } from 'app/shared/components/notifications/notifications.module';
import { QuickChatModule } from 'app/shared/components/quick-chat/quick-chat.module';
import { SearchModule } from 'app/shared/components/search/search.module';
import { ShortcutsModule } from 'app/shared/components/shortcuts/shortcuts.module';
import { CommonModule } from '@angular/common';

@NgModule({ declarations: [ClassyLayoutComponent],
    exports: [ClassyLayoutComponent], imports: [CommonModule,
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        FuseFullscreenModule,
        FuseLoadingBarModule,
        FuseNavigationModule,
        LanguagesModule,
        MessagesModule,
        NotificationsModule,
        QuickChatModule,
        SearchModule,
        ShortcutsModule,
        UserModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ClassyLayoutModule {}
